import React from 'react'
import { NavigateNext, NavigateBefore } from '@mui/icons-material'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Header({ classes, selectedDay, changeMonth }) {
	function thisMonth() {
		return selectedDay.isSame(new Date(), 'month')
	}

	return (
		<div className={classes.header}>
			<div className={classes.calendarPrevious} onClick={() => !thisMonth() && changeMonth(-1)}>{!thisMonth() && <NavigateBefore />}</div>
			<div className='current' style={{ textTransform: 'capitalize' }}>{selectedDay.format('MMMM YYYY')}</div>
			<div className={classes.calendarNext} onClick={() => changeMonth(1)}><NavigateNext /></div>
		</div>
	)
}

export default withStyles(style)(Header)
